import React, { useEffect } from "react";
import { Routes, Route, useNavigate } from "react-router-dom";
import Login from "../screens/front/Login/Login.tsx";
import ProtectedRoute from "./ProtectedRoutes.tsx";
import Unauthorized from "./UnAuthorized.tsx";
import AdminDashboard from "../screens/admin/AdminDashboard/AdminDashboard.tsx";
import ManageAdmin from "../screens/admin/ManageAdmin/ManageAdmin.tsx"; // Import ManageAdmin component
import Home from "../screens/front/Home/Home.tsx";
import Layout from "../Components/Layout/Layout.tsx";
import EditAccessGroup from "../screens/admin/ManageAdmin/EditAccessGroup.tsx";
import AddOrUpdate from "../screens/admin/ManageAdmin/AddOrUpdateAdmin.tsx";
import ManageStore from "../screens/admin/ManageStore/ManageStore.tsx";
import AddOrUpdateStore from "../screens/admin/ManageStore/AddOrUpdateStore.tsx";
import ManageClients from "../screens/admin/ManageClients/ManageClients.tsx";
import AddOrUpdateClients from "../screens/admin/ManageClients/AddOrUpdateClients.tsx";
import ManageVenue from "../screens/admin/ManageVenue/ManageVenue.tsx";
import AddOrUpdateVenue from "../screens/admin/ManageVenue/AddOrUpdateVenue.tsx";
import ImportExportQuestions from "../screens/admin/ImportExportQuestions/ImportExportQuestions.tsx";
import ImportExportQuestionsManager from "../screens/admin/ImportExportQuestionsManager/ImporttExportQuestionsManager.tsx";
import AreaManager from "../screens/admin/AreaManager/AreaManager.tsx";
import AddOrUpdateAreaManager from "../screens/admin/AreaManager/AddOrUpdateAreaManager.tsx";
import VenueMap from "../screens/admin/ManageVenue/VenueMap.tsx";
import BriefJson from "../screens/admin/BriefJson/BriefJson.tsx";
import AddOrUpdateBriefJson from "../screens/admin/BriefJson/AddOrUpdateBriefJson.tsx";
import ViewEditorsBusiness from "../screens/admin/ManageStore/ViewEditorsBusiness.tsx";
import ViewEditorsVenue from "../screens/admin/ManageVenue/ViewEditorsVenue.tsx";
import TermsAndConditions from "../components/TermsAndConditions/TermsAndConditions.tsx";
import TrainingCalendar from "../screens/admin/TrainingCalendar/TrainingCalendar.tsx";
import ManageVisitTime from "../screens/admin/ManageVisitTime/ManageVisitTime.tsx";
import AddOrUpdateManageVisit from "../screens/admin/ManageVisitTime/AddOrUpdateManageVisit.tsx";
import ViewJobCriteriaBusiness from "../screens/admin/ManageStore/ViewJobCriteriaBusiness.tsx";
import ViewJobCriteriaVenue from "../screens/admin/ManageVenue/ViewJobCriteriaVenue.tsx";
import CreateAllocations from "../screens/admin/CreateAllocations/CreateAllocations.tsx";
import ApproveAllocation from "../screens/admin/ApproveAllocation/ApproveAllocation.tsx";
import ShopperApplications from "../screens/admin/ShopperApplications/ShopperApplications.tsx";
import ViewShopperApplication from "../screens/admin/ShopperApplications/ViewShopperApplication.tsx";
import OrphanAllocation from "../screens/admin/OrphanAllocation/OrphanAllocation.tsx";
import InviteShopper from "../screens/admin/OrphanAllocation/InviteShopper.tsx";
import MonthlyCalendar from "../screens/admin/MonthlyCalendar/MonthlyCalendar.tsx";
import CreateNewTemplate from "../screens/admin/CreateNewTemplate/CreateNewTemplate.tsx";
import QuestionBank from "../screens/admin/QuestionBank/QuestionBank.tsx";
import CreateNewQuestion from "../screens/admin/CreateNewQuestion/CreateNewQuestion.tsx";
import TemplateListing from "../screens/admin/Template Listing/TemplateListing.tsx";
import CreateClientTemplate from "../screens/admin/CreateClientTemplate/CreateClientTemplate.tsx";
import CreateVenueSiteTemplate from "../screens/admin/CreateVenueSiteTemplate copy/CreateVenueSiteTemplate.tsx";
import ManageReports from "../screens/admin/ManageReports/ManageReports.tsx";
import CreateOrEditScoreCard from "../screens/admin/ScoreCardComponents/CreateOrEditScoreCard.tsx";
import ShopperRequestDate from '../screens/admin/Shopper Req Date/ShopperRequestDate.tsx'
import StarRatingReport from "../screens/admin/RatingData/StarRatingReport.tsx";
import SpentReport from "../screens/admin/Report/SpentReport.tsx";
import RatingReportYTD from "../screens/admin/RatingData/RatingReportYTD.tsx";
import PositionRankingReport from "../screens/admin/RatingData/PositionRankingReport.tsx";
import QuizManagement from "../screens/admin/QuizManagement/QuizManagement.tsx";
import ShoppersList from "../screens/admin/ShopperList/ShoppersList.tsx";
import EditShopperProfile from "../screens/admin/ShopperList/EditShopperProfile.tsx";
import ShopperVenueMap from "../screens/admin/ShopperVenueMap/ShopperVenueMap.tsx";
import ManageRegions from "../screens/admin/ManageRegions/ManageRegions.tsx";
import AddOrUpdateRegion from "../screens/admin/ManageRegions/AddOrUpdateRegion.tsx";
import ViewAssignRegion from "../screens/admin/ManageStore/ViewAssignRegion.tsx";
import Categorylist from "../screens/admin/Category/Categorylist.tsx";
import AddorUpdateCategory from "../screens/admin/Category/AddorUpdateCategory.tsx";
import RegionBusinessDetails from "../screens/admin/RegionBusinessDetails/RegionBusinessDetails.tsx";
import AddOrEditRegionBusinessDetails from "../screens/admin/RegionBusinessDetails/AddOrEditRegionBusinessDetails.tsx";
import AirTaskerList from "../screens/admin/AirTasker/AirTaskerList.tsx";
import AirTasker from "../screens/admin/AirTasker/AirTasker.tsx";
import AirTaskerJobs from "../screens/admin/AirTasker/AirTaskerJobs.tsx";
import BundleAllocation from "../screens/admin/BundleAllocation/BundleAllocation.tsx";
import CreateBundleAllocation from "../screens/admin/BundleAllocation/CreateBundleAllocation.tsx";
import GenerateInvoice from "../screens/admin/Invoice/GenerateInvoice.tsx";
import EditorDashboard from "../screens/editor/EditorDashboard.tsx";
import EditorLayout from "../Components/Layout/EditorLayout.tsx";
import AllocationDetails from "../screens/admin/AllocationDetails/AllocationDetails.tsx";
import ImportExportAllocations from "../screens/admin/Import-Export-Allocations/ImportExportAllocations.tsx";
import UpdatePricing from "../screens/admin/Update Pricing/UpdatePricing.tsx";
import CompleteAllocation from "../screens/admin/CompleteAllocation/CompleteAllocation.tsx";
import PayInvoice from "../screens/admin/Invoice/PayInvoice.tsx";
import Invoicedetails from "../screens/admin/Invoice/Invoicedetails.tsx";
import AssignShopper from "../screens/admin/OrphanAllocation/AssignShopper.tsx";
import RestrictScreen from "../screens/admin/Restrict Screen/RestrictScreen.tsx";
import EmailPreference from "../screens/admin/EmailSettings/emailPreference.tsx";
import ManageHoliday from "../screens/admin/ManageHoliday/ManageHoliday.tsx";
import AddOnQuestion from "../screens/admin/AddOnquestion/AddonQuestion.tsx";
import AddNewAddOnQuestion from "../screens/admin/AddOnquestion/AddNewAddOnQuestion.tsx";
import StarRating from "../screens/admin/StarRating/StarRating.tsx";
import StarRatingForm from "../screens/admin/StarRating/StarRatingForm.tsx";
import MoveApprovedAllocations from "../screens/admin/Move Approved Allocations/MoveApprovedAllocations.tsx";
import BulkShopperReset from "../screens/admin/Bulk Shopper Reset/BulkShopperReset.tsx";
import HelpDocument from "../screens/admin/HelpDocument/HelpDocument.tsx";
import AddOrUpdateDocument from "../screens/admin/HelpDocument/AddOrUpdateDocument.tsx";
import WeeklyCalendar from "../screens/admin/WeeklyCalendar/WeeklyCalendar.tsx";
import CreateOrUpdateNewBundleAllocation from "../screens/admin/NewBundleAllocation/CreateOrUpdateNewBundleAllocation.tsx";
import NewBundleAllocation from "../screens/admin/NewBundleAllocation/NewBundleAllocation.tsx";
import BulkRegionUpdate from "../screens/admin/Bulk Region update/BulkRegionUpdate.tsx";
import ManageUser from "../screens/admin/ManageClients/ManageUser.tsx";
import VenueReportStatus from "../screens/admin/VenueReportStatus/VenueReportStatus.tsx";
import SetQuestionOrder from "../screens/admin/CreateClientTemplate/SetQuestionOrder.tsx";
import VenueUsers from "../screens/admin/ManageVenue/VenueUsers.tsx";
import AreaUsers from "../screens/admin/ManageStore/AreaUsers.tsx";
import SetVenueQuestionOrder from "../screens/admin/CreateVenueSiteTemplate copy/SetQuestionOrder.tsx";
import CategoryReport from "../screens/admin/Category Report/CategoryReport.tsx";
import CancelledAllocation from "../screens/admin/CancelledAllocation/CancelledAllocation.tsx";
import AllocationSummary from "../screens/admin/AllocationSummary/AllocationSummary.tsx";
import PendingAllocation from "../screens/admin/PendingAllocation/PendingAllocation.tsx";
import SetTemplateQuestionOrder from "../screens/admin/CreateNewTemplate/SetQuestionOrder.tsx";
import DShopper from "../screens/admin/DormantShopper/DormantShopper.tsx";
import DisabledTraining from "../screens/admin/Training Disabled/DisabledTraining.tsx";
import PendingTraining from "../screens/admin/Training Pending/PendingTraining.tsx";
import RelatedSites from "../screens/admin/RelatedSites/RelatedSites.tsx";
import AddorUpdateHolidays from "../screens/admin/ManageStore/AddorUpdateHolidays.tsx";
import StaffManager from "../screens/admin/StaffManager/StaffManager.tsx";
import StoreScenarios from "../screens/admin/StoreScenarios/StoreScenarios.tsx";
import StaffMember_UseCases from "../screens/admin/JBHifiMemberCases/StaffMember_UseCases.tsx";
import ChecklistCategorylist from "../screens/admin/Checklist/Checklit Category/ChecklistCategorylist.tsx";
import ChecklistQuestionBank from "../screens/admin/Checklist/Checklist QuestionBank/ChecklistQuestionBank.tsx";
import CreateNewChecklistQuestion from "../screens/admin/Checklist/CreateNewChecklistQuestion/CreateNewChecklistQuestion.tsx";
import ChecklistTemplateListing from "../screens/admin/Checklist/Checklist Template Listing/ChecklistTemplateListing.tsx";
import CreateTemplateQuestions from "../screens/admin/Checklist/Checklist Template Listing/CreateTemplateQuestions.tsx";
import ChangetemplateQuestionOrder from "../screens/admin/Checklist/Checklist Template Listing/ChangetemplateQuestionOrder.tsx";

// Brief Management Module Components
import BriefIconList from "../screens/admin/Brief/BriefIconList.tsx";
import BriefTitleList from "../screens/admin/Brief/BriefTitleList.tsx";
import BusinessBriefList from "../screens/admin/Brief/BusinessBriefList.tsx";
import VenueBriefList from "../screens/admin/Brief/VenueBriefList.tsx";
import CheckShopperEligibility from "../screens/admin/Check Shopper Eligibility/CheckShopperEligibility.tsx";
import OtpVerification from "../screens/front/2fA/OtpVerification.tsx";
import { useDispatch } from "react-redux";
import { roleRedirects } from "../global/constants/roleRedirects.tsx";
import { toast } from "react-toastify";
import ManageReportQuestions from "../screens/admin/ManageReportQuestions/ManageReportQuestions.tsx";
import ToDo from "../screens/admin/To Do/ToDo.tsx";

const AppRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/login" element={<Login />} />
      <Route path="/verify" element={<OtpVerification />} />
      <Route path="/unauthorized" element={<Unauthorized />} />
      <Route path="/venue-map" element={<VenueMap />} />

      {/* Protected Route for Admin Dashboard */}
      <Route
        path="/admin/dashboard"
        element={
          <ProtectedRoute allowedRoles={["1", "2"]}>
            <Layout>
              <AdminDashboard />
            </Layout>
          </ProtectedRoute>
        }
      />

      {/* Protected Route for Manage Admin */}
      <Route
        path="/admin/manage-admin"
        element={
          <ProtectedRoute allowedRoles={["1"]}>
            <Layout>
              <ManageAdmin /> {/* Use ManageAdmin component here */}
            </Layout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/admin/manage-store"
        element={
          <ProtectedRoute allowedRoles={["1", "2"]}>
            <Layout>
              <ManageStore />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/manage-clients"
        element={
          <ProtectedRoute allowedRoles={["1", "2"]}>
            <Layout>
              <ManageClients />
            </Layout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/admin/venue-managers"
        element={
          <ProtectedRoute allowedRoles={["1", "2"]}>
            <Layout>
              <ManageVenue />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/related-sites"
        element={
          <ProtectedRoute allowedRoles={["1", "2"]}>
            <Layout>
              <RelatedSites />
            </Layout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/admin/import-export"
        element={
          <ProtectedRoute allowedRoles={["1", "2"]}>
            <Layout>
              <ImportExportQuestions />
            </Layout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/admin/import-export-manager"
        element={
          <ProtectedRoute allowedRoles={["1", "2"]}>
            <Layout>
              <ImportExportQuestionsManager />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/question-bank"
        element={
          <ProtectedRoute allowedRoles={["1", "2"]}>
            <Layout>
              <QuestionBank />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/create-new-question"
        element={
          <ProtectedRoute allowedRoles={["1", "2"]}>
            <Layout>
              <CreateNewQuestion />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/create-new-question/:questionId"
        element={
          <ProtectedRoute allowedRoles={["1", "2"]}>
            <Layout>
              <CreateNewQuestion />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/create-new-question/client/:clientEntityId/:questionId"
        element={
          <ProtectedRoute allowedRoles={["1", "2"]}>
            <Layout>
              <CreateNewQuestion />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/create-new-question/template/:entityTypeTemplateId/:questionId"
        element={
          <ProtectedRoute allowedRoles={["1", "2"]}>
            <Layout>
              <CreateNewQuestion />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/create-new-question/venue/:venueId/:questionId"
        element={
          <ProtectedRoute allowedRoles={["1", "2"]}>
            <Layout>
              <CreateNewQuestion />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/brief-json"
        element={
          <ProtectedRoute allowedRoles={["1", "2"]}>
            <Layout>
              <BriefJson />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/create-new-template/:templateName/:entityTypeTemplateId"
        element={
          <ProtectedRoute allowedRoles={["1", "2"]}>
            <Layout>
              <CreateNewTemplate />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/create-client-template/:id"
        element={
          <ProtectedRoute allowedRoles={["1", "2"]}>
            <Layout>
              <CreateClientTemplate />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/create-venue-site-template/:id"
        element={
          <ProtectedRoute allowedRoles={["1", "2"]}>
            <Layout>
              <CreateVenueSiteTemplate />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/create-venue-site-users/:id"
        element={
          <ProtectedRoute allowedRoles={["1", "2"]}>
            <Layout>
              <VenueUsers />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/manage-reports"
        element={
          <ProtectedRoute allowedRoles={["1", "2"]}>
            <Layout>
              <ManageReports />
            </Layout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/admin/area-managers"
        element={
          <ProtectedRoute allowedRoles={["1", "2"]}>
            <Layout>
              <AreaManager />
            </Layout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/admin/disabled-training"
        element={
          <ProtectedRoute allowedRoles={["1", "2"]}>
            <Layout>
              <DisabledTraining />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/pending-training"
        element={
          <ProtectedRoute allowedRoles={["1", "2"]}>
            <Layout>
              <PendingTraining />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/training-calendar"
        element={
          <ProtectedRoute allowedRoles={["1", "2"]}>
            <Layout>
              <TrainingCalendar />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/editor/training-calendar"
        element={
          <ProtectedRoute allowedRoles={["3"]}>
            <EditorLayout>
              <TrainingCalendar />
            </EditorLayout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/admin/clients-update/:mode/:id?"
        element={
          <ProtectedRoute allowedRoles={["1", "2"]}>
            <Layout>
              <AddOrUpdateClients
                onSubmit={function (values: any): void { }}
                mode={"add"}
              />
            </Layout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/admin/add-or-update/:mode/:id?"
        element={
          <ProtectedRoute allowedRoles={["1", "2"]}>
            <Layout>
              <AddOrUpdate
                onSubmit={function (values: any): void { }}
                mode={"add"}
              />
            </Layout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/admin/add-or-update-store/:mode/:id?"
        element={
          <ProtectedRoute allowedRoles={["1", "2"]}>
            <Layout>
              <AddOrUpdateStore
                onSubmit={function (values: any): void { }}
                mode={"add"}
              />
            </Layout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/admin/add-or-update-venue/:mode/:id?"
        element={
          <ProtectedRoute allowedRoles={["1", "2"]}>
            <Layout>
              <AddOrUpdateVenue
                onSubmit={function (values: any): void { }}
                mode={"add"}
              />
            </Layout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/admin/add-or-update-areamanager/:mode/:id?"
        element={
          <ProtectedRoute allowedRoles={["1", "2"]}>
            <Layout>
              <AddOrUpdateAreaManager
                onSubmit={function (values: any): void { }}
                mode={"add"}
              />
            </Layout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/admin/add-or-update-briefjson/:mode/:id?"
        element={
          <ProtectedRoute allowedRoles={["1", "2"]}>
            <Layout>
              <AddOrUpdateBriefJson
                onSubmit={function (values: any): void { }}
                mode={"add"}
              />
            </Layout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/admin/edit-access-group"
        element={
          <ProtectedRoute allowedRoles={["1"]}>
            <Layout>
              <EditAccessGroup />
            </Layout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/admin/view-editor-business/:id"
        element={
          <ProtectedRoute allowedRoles={["1", "2"]}>
            <Layout>
              <ViewEditorsBusiness
                onSubmit={function (values: any): void {
                  throw new Error("Function not implemented.");
                }}
              />
            </Layout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/admin/view-editor-site/:id"
        element={
          <ProtectedRoute allowedRoles={["1", "2"]}>
            <Layout>
              <ViewEditorsVenue
                onSubmit={function (values: any): void {
                  throw new Error("Function not implemented.");
                }}
              />
            </Layout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/admin/view-business-jobcriteria/:id"
        element={
          <ProtectedRoute allowedRoles={["1", "2"]}>
            <Layout>
              <ViewJobCriteriaBusiness
                onSubmit={function (values: any): void {
                  throw new Error("Function not implemented.");
                }}
              />
            </Layout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/admin/view-venue-jobcriteria/:id"
        element={
          <ProtectedRoute allowedRoles={["1", "2"]}>
            <Layout>
              <ViewJobCriteriaVenue
                onSubmit={function (values: any): void {
                  throw new Error("Function not implemented.");
                }}
              />
            </Layout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/admin/allocations/manage-visit-times"
        element={
          <ProtectedRoute allowedRoles={["1", "2"]}>
            <Layout>
              <ManageVisitTime />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/allocations/export-pdf-excel"
        element={
          <ProtectedRoute allowedRoles={["1", "2"]}>
            <Layout>
              <ImportExportAllocations />
            </Layout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/admin/allocations/add-or-update-visittime/:mode/:id?"
        element={
          <ProtectedRoute allowedRoles={["1", "2"]}>
            <Layout>
              <AddOrUpdateManageVisit
                onSubmit={function (values: any): void { }}
                mode={"add"}
              />
            </Layout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/admin/allocations/create-monthly-allocation"
        element={
          <ProtectedRoute allowedRoles={["1", "2"]}>
            <Layout>
              <CreateAllocations />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/allocations/approve-allocation"
        element={
          <ProtectedRoute allowedRoles={["1", "2"]}>
            <Layout>
              <ApproveAllocation />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/allocations/bulk-approved-allocation"
        element={
          <ProtectedRoute allowedRoles={["1", "2"]}>
            <Layout>
              <MoveApprovedAllocations />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/allocations/bulk-shopper-reset"
        element={
          <ProtectedRoute allowedRoles={["1", "2"]}>
            <Layout>
              <BulkShopperReset />
            </Layout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/admin/shoppers/shopper-application"
        element={
          <ProtectedRoute allowedRoles={["1", "2"]}>
            <Layout>
              <ShopperApplications />
            </Layout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/admin/shoppers/view-shopper-application/:id"
        element={
          <ProtectedRoute allowedRoles={["1", "2"]}>
            <Layout>
              <ViewShopperApplication />
            </Layout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/admin/allocations/orphan-allocation"
        element={
          <ProtectedRoute allowedRoles={["1", "2"]}>
            <Layout>
              <OrphanAllocation />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/allocations/Invite-Shopper/:id"
        element={
          <ProtectedRoute allowedRoles={["1", "2"]}>
            <Layout>
              <InviteShopper />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="admin/allocations/monthly-calendar"
        element={
          <ProtectedRoute allowedRoles={["1", "2"]}>
            <Layout>
              <MonthlyCalendar />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="admin/allocations/weekly-calendar"
        element={
          <ProtectedRoute allowedRoles={["1", "2"]}>
            <Layout>
              <WeeklyCalendar />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/allocation-details/:allocationId?"
        element={
          <ProtectedRoute allowedRoles={["1", "2"]}>
            <Layout>
              <AllocationDetails />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/editor/allocation-details/:allocationId?"
        element={
          <ProtectedRoute allowedRoles={["3"]}>
            <EditorLayout>
              <AllocationDetails />
            </EditorLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/template-listing"
        element={
          <ProtectedRoute allowedRoles={["1", "2"]}>
            <Layout>
              <TemplateListing />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/manage-reports"
        element={
          <ProtectedRoute allowedRoles={["1", "2"]}>
            <Layout>
              <ManageReports />
            </Layout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/createOrEditScoreCard/:allocationId"
        element={
          <ProtectedRoute allowedRoles={["1", "2"]}>
            <Layout>
              <CreateOrEditScoreCard />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path='/admin/allocations/shopper-date-request'
        element={
          <ProtectedRoute allowedRoles={['1', '2']}>
            <Layout>
              <ShopperRequestDate />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path='/admin/rating-data/star-rating-report'
        element={
          <ProtectedRoute allowedRoles={['1', '2']}>
            <Layout>
              <StarRatingReport />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path='/admin/spent-report'
        element={
          <ProtectedRoute allowedRoles={['1', '2']}>
            <Layout>
              <SpentReport />
            </Layout>
          </ProtectedRoute>
        }
      />
      {/* <Route
        path='/admin/create-quiz-question/:id'
        element={
          <ProtectedRoute allowedRoles={['1', '2']}>
            <Layout>
              <QuizManagement />
            </Layout>
          </ProtectedRoute>
        }
      /> */}
      <Route
        path='/admin/addOrUpdateHolidays/:id'
        element={
          <ProtectedRoute allowedRoles={['1', '2']}>
            <Layout>
              <AddorUpdateHolidays />
            </Layout>
          </ProtectedRoute>
        }
      />

      <Route
        path='/admin/shoppers/shoppers-list'
        element={
          <ProtectedRoute allowedRoles={['1', '2']}>
            <Layout>
              <ShoppersList />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path='/admin/shoppers/edit_shopper_profile/:id'
        element={
          <ProtectedRoute allowedRoles={['1', '2']}>
            <Layout>
              <EditShopperProfile />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path='/admin/others/shopper-venue-map'
        element={
          <ProtectedRoute allowedRoles={['1', '2']}>
            <Layout>
              <ShopperVenueMap />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/manage-region"
        element={
          <ProtectedRoute allowedRoles={["1", "2"]}>
            <Layout>
              <ManageRegions />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path='/admin/rating-data/position-ranking-report'
        element={
          <ProtectedRoute allowedRoles={['1', '2']}>
            <Layout>
              <PositionRankingReport />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path='/admin/others/category-list'
        element={
          <ProtectedRoute allowedRoles={['1', '2']}>
            <Layout>
              <Categorylist />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path='/admin/others/add-or-upate-category'
        element={
          <ProtectedRoute allowedRoles={['1', '2']}>
            <Layout>
              <AddorUpdateCategory />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path='/admin/others/add-or-upate-category/:id'
        element={
          <ProtectedRoute allowedRoles={['1', '2']}>
            <Layout>
              <AddorUpdateCategory />
            </Layout>
          </ProtectedRoute>
        }
      />

      {/* Brief Management Module Routes */}
      <Route
        path='/admin/brief/brief-icon'
        element={
          <ProtectedRoute allowedRoles={['1', '2']}>
            <Layout>
              <BriefIconList />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path='/admin/brief/brief-title'
        element={
          <ProtectedRoute allowedRoles={['1', '2']}>
            <Layout>
              <BriefTitleList />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path='/admin/manage-business-brief/:clientEntityId'
        element={
          <ProtectedRoute allowedRoles={['1', '2']}>
            <Layout>
              <BusinessBriefList />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path='/admin/manage-venue-brief/:venueId'
        element={
          <ProtectedRoute allowedRoles={['1', '2']}>
            <Layout>
              <VenueBriefList />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/add-or-update-region/:mode/:id?"
        element={
          <ProtectedRoute allowedRoles={["1", "2"]}>
            <Layout>
              <AddOrUpdateRegion
                onSubmit={function (values: any): void { }}
                mode={"add"}
              />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path='/admin/region-business-details'
        element={
          <ProtectedRoute allowedRoles={['1', '2']}>
            <Layout>
              <RegionBusinessDetails />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/add-or-update-regionBusinessDetail/:mode/:id?"
        element={
          <ProtectedRoute allowedRoles={["1", "2"]}>
            <Layout>
              <AddOrEditRegionBusinessDetails
                onSubmit={function (values: any): void { }}
                mode={"add"}
              />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path='/admin/shoppers/airtasker'
        element={
          <ProtectedRoute allowedRoles={['1', '2']}>
            <Layout>
              <AirTaskerList />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path='/admin/shoppers/d-Shopper'
        element={
          <ProtectedRoute allowedRoles={['1', '2']}>
            <Layout>
              <DShopper />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/shopper/:mode/:id?"
        element={
          <ProtectedRoute allowedRoles={["1", "2"]}>
            <Layout>
              <AirTasker
                onSubmit={() => { }} mode="add"
              />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/allocations/airtasker-jobs"
        element={
          <ProtectedRoute allowedRoles={["1", "2"]}>
            <Layout>
              <AirTaskerJobs />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/allocations/createbundle-allocations/"
        element={
          <ProtectedRoute allowedRoles={["1", "2"]}>
            <Layout>
              <CreateBundleAllocation />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/allocations/createbundle-allocations/:currentdate/:id"
        element={
          <ProtectedRoute allowedRoles={["1", "2"]}>
            <Layout>
              <CreateBundleAllocation />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/allocations/bundle-allocations"
        element={
          <ProtectedRoute allowedRoles={["1", "2"]}>
            <Layout>
              <BundleAllocation />
            </Layout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/admin/invoices/generate-invoice"
        element={
          <ProtectedRoute allowedRoles={["1"]}>
            <Layout>
              <GenerateInvoice />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/invoices/pay-invoice"
        element={
          <ProtectedRoute allowedRoles={["1"]}>
            <Layout>
              <PayInvoice />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/invoices/invoice-details/:shopperInvoiceId"
        element={
          <ProtectedRoute allowedRoles={["1"]}>
            <Layout>
              <Invoicedetails />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/editor/dashboard"
        element={
          <ProtectedRoute allowedRoles={["3"]}>
            <EditorLayout>
              <EditorDashboard />
            </EditorLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/editor/manage-report"
        element={
          <ProtectedRoute allowedRoles={["3"]}>
            <EditorLayout>
              <ManageReports />
            </EditorLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/editor/monthly-calendar"
        element={
          <ProtectedRoute allowedRoles={["3"]}>
            <EditorLayout>
              <MonthlyCalendar />
            </EditorLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/allocations/update-pricing"
        element={
          <ProtectedRoute allowedRoles={["1", "2"]}>
            <Layout>
              <UpdatePricing />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/allocations/view-completed-allocation"
        element={
          <ProtectedRoute allowedRoles={["1", "2"]}>
            <Layout>
              <CompleteAllocation />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/rating-data/star-ranking-report-ytd"
        element={
          <ProtectedRoute allowedRoles={["1", "2"]}>
            <Layout>
              <RatingReportYTD />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/allocations/assign-Shopper/:currentdate/:id"
        element={
          <ProtectedRoute allowedRoles={["1", "2"]}>
            <Layout>
              <AssignShopper />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/allocations/restrict-access"
        element={
          <ProtectedRoute allowedRoles={["1", "2"]}>
            <Layout>
              <RestrictScreen />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="admin/emailSettings/email-preference"
        element={
          <ProtectedRoute allowedRoles={["1", "2"]}>
            <Layout>
              <EmailPreference />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/allocations/manage-holidays"
        element={
          <ProtectedRoute allowedRoles={["1", "2"]}>
            <Layout>
              <ManageHoliday />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/others/add-on-question"
        element={
          <ProtectedRoute allowedRoles={["1", "2"]}>
            <Layout>
              <AddOnQuestion />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/others/add/add-on-question"
        element={
          <ProtectedRoute allowedRoles={["1", "2"]}>
            <Layout>
              <AddNewAddOnQuestion />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/others/star-rating"
        element={
          <ProtectedRoute allowedRoles={["1", "2"]}>
            <Layout>
              <StarRating />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/others/add/star-rating"
        element={
          <ProtectedRoute allowedRoles={["1", "2"]}>
            <Layout>
              <StarRatingForm />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/others/help-document"
        element={
          <ProtectedRoute allowedRoles={["1", "2"]}>
            <Layout>
              <HelpDocument />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/allocations/createOrUpdateNewbundle-allocations/"
        element={
          <ProtectedRoute allowedRoles={["1", "2"]}>
            <Layout>
              <CreateOrUpdateNewBundleAllocation />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/allocations/createOrUpdateNewbundle-allocations/:currentdate/:id"
        element={
          <ProtectedRoute allowedRoles={["1", "2"]}>
            <Layout>
              <CreateOrUpdateNewBundleAllocation />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/allocations/newBundle-allocations"
        element={
          <ProtectedRoute allowedRoles={["1", "2"]}>
            <Layout>
              <NewBundleAllocation />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/allocations/bulk-region-update"
        element={
          <ProtectedRoute allowedRoles={["1", "2"]}>
            <Layout>
              <BulkRegionUpdate />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/manage-clients/user/:clientId"
        element={
          <ProtectedRoute allowedRoles={["1", "2"]}>
            <Layout>
              <ManageUser />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/venue-reports/:id"
        element={
          <ProtectedRoute allowedRoles={["1", "2"]}>
            <Layout>
              <VenueReportStatus />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/editor/venue-reports/:id"
        element={
          <ProtectedRoute allowedRoles={["3"]}>
            <EditorLayout>
              <VenueReportStatus />
            </EditorLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/change-question-order/:clienEntityName/:clientEntityId"
        element={
          <ProtectedRoute allowedRoles={["1", "2"]}>
            <Layout>
              <SetQuestionOrder />
            </Layout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/admin/change-venue-question-order/:venueName/:venueId"
        element={
          <ProtectedRoute allowedRoles={["1", "2"]}>
            <Layout>
              <SetVenueQuestionOrder />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/category-report"
        element={
          <ProtectedRoute allowedRoles={["1", "2"]}>
            <Layout>
              <CategoryReport />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/allocations/cancelled-allocation"
        element={
          <ProtectedRoute allowedRoles={["1", "2"]}>
            <Layout>
              <CancelledAllocation />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/allocations/allocation-summary"
        element={
          <ProtectedRoute allowedRoles={["1", "2"]}>
            <Layout>
              <AllocationSummary />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/allocations/pending-allocation"
        element={
          <ProtectedRoute allowedRoles={["1", "2"]}>
            <Layout>
              <PendingAllocation />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/change-template-question-order/:entityTemplateName/:entityTypeTemplateId"
        element={
          <ProtectedRoute allowedRoles={["1", "2"]}>
            <Layout>
              <SetTemplateQuestionOrder />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/create-venue-site-staff/:id"
        element={
          <ProtectedRoute allowedRoles={["1", "2"]}>
            <Layout>
              <StaffManager />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="admin/manage-scenarios/:id"
        element={
          <ProtectedRoute allowedRoles={["1", "2"]}>
            <Layout>
              <StoreScenarios />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="admin/allocations/manage-staff-member-cases"
        element={
          <ProtectedRoute allowedRoles={["1", "2"]}>
            <Layout>
              <StaffMember_UseCases />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="admin/allocations/check-shopper-eligibility"
        element={
          <ProtectedRoute allowedRoles={["1", "2"]}>
            <Layout>
              <CheckShopperEligibility />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="admin/checklist/checklist-category"
        element={
          <ProtectedRoute allowedRoles={["1", "2"]}>
            <Layout>
              <ChecklistCategorylist />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="admin/checklist/checklist-question-bank"
        element={
          <ProtectedRoute allowedRoles={["1", "2"]}>
            <Layout>
              <ChecklistQuestionBank />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="admin/checklist/create-new-question/:questionId"
        element={
          <ProtectedRoute allowedRoles={["1", "2"]}>
            <Layout>
              <CreateNewChecklistQuestion />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="admin/checklist/create-new-question"
        element={
          <ProtectedRoute allowedRoles={["1", "2"]}>
            <Layout>
              <CreateNewChecklistQuestion />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="admin/checklist/create-new-question/:checklistTemplateId/:checklistTemplateQuestionId"
        element={
          <ProtectedRoute allowedRoles={["1", "2"]}>
            <Layout>
              <CreateNewChecklistQuestion />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="admin/checklist/cheklist-question-template"
        element={
          <ProtectedRoute allowedRoles={["1", "2"]}>
            <Layout>
              <ChecklistTemplateListing />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="admin/checklist/template-question/:templateName/:checklistTemplateId"
        element={
          <ProtectedRoute allowedRoles={["1", "2"]}>
            <Layout>
              <CreateTemplateQuestions />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="admin/change-checklist-template-question-order/:templateName/:templateId"
        element={
          <ProtectedRoute allowedRoles={["1", "2"]}>
            <Layout>
              <ChangetemplateQuestionOrder />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="admin/reports/manage-report-questions"
        element={
          <ProtectedRoute allowedRoles={["1", "2"]}>
            <Layout>
              <ManageReportQuestions />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="admin/to-do"
        element={
          <ProtectedRoute allowedRoles={["1", "2","3"]}>
            <Layout>
              <ToDo />
            </Layout>
          </ProtectedRoute>
        }
      />
    </Routes>
  );
};

export default AppRoutes;
